import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { TemplatedExpressionEditor } from '@cotera/client/app/components/eraql-editor';
import { Text } from '@cotera/client/app/components/ui/text';
import { useMemo } from 'react';
import { DG } from '@cotera/sdk/core';

export const ExpressionNodeView = ({
  node,
  updateAttributes,
  extension,
}: NodeViewProps) => {
  const eraql = (node.attrs['eraql'] as string) || '';
  const options = extension.options as {
    parser?: DG.Graph.RelativeParser;
  };

  const parser = useMemo(() => {
    if (!options.parser) {
      return undefined;
    }

    return options.parser;
  }, [options.parser]);

  // If no parser is available, show a message
  if (!parser) {
    return (
      <NodeViewWrapper
        className="expression-node react-renderer mt-4"
        data-drag-handle
      >
        <div
          className="p-2 border rounded-md bg-yellow-100 select-none border-yellow-300 flex flex-col gap-2"
          contentEditable={false}
          suppressContentEditableWarning
        >
          <Text.Label className="text-yellow-700 font-medium">
            Expression Editor
          </Text.Label>
          <Text.Caption className="text-yellow-600">
            Parser not configured. Please provide a parser in the extension
            options.
          </Text.Caption>
        </div>
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper
      className="expression-node react-renderer mt-4"
      data-drag-handle
    >
      <div
        className="p-2 border rounded-md bg-gray-100 select-none border-gray-300 flex flex-col gap-2"
        contentEditable={false}
        suppressContentEditableWarning
      >
        <Text.Label className="text-gray-500 font-medium">
          Expression
        </Text.Label>
        <div className="flex flex-col w-full bg-background rounded-md prose-ignore">
          <TemplatedExpressionEditor
            className="!pt-4 !pb-0"
            eraql={eraql}
            templated={false}
            type="expr"
            height={100}
            parser={parser}
            onChange={(value) => {
              updateAttributes({
                eraql: value,
              });
            }}
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
};
